<template>
  <div v-for="(actions, attribute) in properties" :key="attribute">
    <div v-if="actions !== null" class="row">
      <div class="col-3" style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
        {{ trans(`models.${resourceType}.attributes.${attribute}`) }}:
      </div>
      <div class="col-9">
        <div v-for="(media, action) in actions" :key="action">
          <div v-if="media !== null">
            <div v-for="(data, id) in media" :key="id">
              <media-field :action="action" :value="data"></media-field>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MediaField from '@kanrisha/components/Presentation/MediaField';

export default {
  components: {
    MediaField,
  },
  props: {
    properties: { type: Object, default: () => {} },
    relations: { type: Object, default: () => {} },
    resourceType: { type: String, default: () => '' },
    meta: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
